import { create } from 'zustand';
import { todayWorkingDayKey, tomorrowWorkingDayKey } from '@/shared/lib/working-day';

interface WorkingDayState {
  dateKey: string;
  setDateKey: (dateKey: string) => void;
  setToday: () => void;
  setTomorrow: () => void;
}

/**
 * Shared ops-day selection for header chip + appointment day views.
 * Keys are IST calendar dates (`yyyy-MM-dd`).
 */
export const useWorkingDayStore = create<WorkingDayState>((set) => ({
  dateKey: todayWorkingDayKey(),

  setDateKey(dateKey) {
    set({ dateKey });
  },

  setToday() {
    set({ dateKey: todayWorkingDayKey() });
  },

  setTomorrow() {
    set({ dateKey: tomorrowWorkingDayKey() });
  },
}));
